<ng-container>
    <div id="moreInformationAlert"
        class="d-none p-2 ms-0 mb-0 alert alert-info border-info default-font-size mt-3 row row-cols-12 row-cols-xs-12 row-cols-sm-12 row-cols-md-12 row-cols-lg-12 row-cols-xl-12 row-cols-xxl-12"
        role="alert">
        <div class="col-11">
            <span class="pt-2" translate="Request.BuilderMessage"></span>
            <button class="btn btn-info btn-sm ms-3" translate="Request.MoreInformation"
                (click)="openMoreInformationPage()"></button>
        </div>
        <div class="col-1 float-end">
            <i class="float-end bi bi-large bi-x-lg pe-2 pt-1" (click)="closeMoreInformationPageRequestBuilder()"></i>
        </div>
    </div>
    <div class="row pt-4">
        <form class="row col-9 ms-0 ps-0" [formGroup]="form">
            <!-- always display a request Title input -->
            <div class="mb-3 col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4">
                <label for="titleInput" class="form-label text-truncate d-block" translate="Request.RequestTitle.Title">
                </label>
                <input type="text" Id="titleInput" class="form-control" placeholder="{{ 'Request.Title' | translate }}"
                    (input)="UpdateTitle()" [formControl]="requestTitleControl" />
                <app-formcontrol-error-messages [forControl]="requestTitleControl"></app-formcontrol-error-messages>
            </div>

            <!-- Display a workgroup picker if there are workgroups allowed -->
            <ng-container *ngIf="allowedWorkgroups && allowedWorkgroups.length > 0">
                <div class="mb-3 col-9 col-sm-9 col-md-4 col-lg-3 col-xl-3 col-xxl-3">
                    <label for="workgroupSelector" class="form-label text-truncate d-block"
                        translate="Request.RequestTitle.Workgroup">
                    </label>
                    <div ngbDropdown class="dropdown" ngDefaultControl formControlName="workgroup" name="workgroup"
                        id="workgroup">
                        <button class="btn btn-sm dropdown-toggle form-control text-truncate default" type="button"
                            id="dropdownMenu" ngbDropdownToggle>
                            {{ selectedWorkgroupName }}
                            <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                            <button ngbDropdownItem value="{{null}}" (click)="changeWorkgroup(null)"
                                translate="Request.RequestTitle.Noworkgroup"></button>
                            <button *ngFor='let workgroupModel of allowedWorkgroups' ngbDropdownItem
                                value="{{workgroupModel.Guid}}"
                                (click)="changeWorkgroup(workgroupModel)">{{workgroupModel.Name}}</button>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Display a clearance level picker if workgroup has been picked -->
            <ng-container *ngIf="showClearancelevelPicker">
                <div class="mb-3 col-6 col-sm-6 col-md-4 col-lg-2 col-xl-2 col-xxl-2">
                    <label for="clearanceSelector" class="form-label text-truncate d-block"
                        translate="Request.RequestTitle.Clearance">
                        <app-info-button labelName="Request.RequestTitle.ClearanceInfoButton" [url]="ClearancelevelUrl">
                        </app-info-button>
                    </label>

                    <div ngbDropdown class="dropdown" ngDefaultControl formControlName="clearancelevel"
                        name="clearancelevel" id="clearancelevel">
                        <button class="btn btn-sm dropdown-toggle form-control text-truncate default" type="button"
                            id="dropdownMenu" ngbDropdownToggle>
                            {{ request.clearancelevel }}
                            <em class="bi bi-chevron-down float-end" aria-hidden="true"></em>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownMenu">
                            <ng-container *ngFor='let clearancelevelValue of allowedClearanceLevels;'>
                                <ng-container *ngIf="clearancelevelValue <= maxClearanceLevelAllowed">
                                    <button ngbDropdownItem value="{{clearancelevelValue}}"
                                        (click)="changeCurrentClearancelevel(clearancelevelValue)">
                                        {{clearancelevelValue}}
                                    </button>
                                </ng-container>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
        </form>
        <ng-container *ngIf="isLatestTab()">
            <div class="col-3 pe-0 text-end">
                <button class="btn btn-sm btn-success mt-4" [disabled]="isGotoRequestDisabled" (click)="sendRequest()"
                    translate="{{isInFirstSendgroup ? 'Button.GoToRequest' : 'Button.SendRequest'}}"></button>
            </div>
        </ng-container>
    </div>
</ng-container>